import {Component, Input, OnChanges, SimpleChanges, SimpleChange, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { environment } from '@env/environment';
import {Logger, I18nService, AuthenticationService, Credentials} from '@app/core';
import {Http} from '@angular/http';
import {AuthService, FacebookLoginProvider, GoogleLoginProvider, SocialUser} from 'angularx-social-login';
import {CustomerService} from '@app/customer/customer.service';
import {DatePipe} from '@angular/common';
import {CustomerModel} from '../../models/customer.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UtilityService} from '@app/core';
import {AccreditedService} from '@app/accredited/accredited.service';

const log = new Logger('Login');

@Component({
  selector: 'app-login-component',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnChanges, OnInit {
  @Input() isModal: boolean;
  @Input() redirectTo: string;
  @Input() shoppingName: string;

  version: string = environment.version;
  error: string;
  customerRegister: CustomerModel = new CustomerModel();
  passwordRegister: string;
  loginForm: FormGroup;
  accreditedLoginForm: FormGroup;
  registerForm: FormGroup;
  forgotForm: FormGroup;
  forgotEmail: string;
  contentSucess: any;
  forgotSended: boolean;
  isLoading = false;
  isAccredited = false;
  isRegister = false;
  isFacebook = false;
  isSocial = false;
  isRegisterSocial = false;
  cpf: string = null;
  cpfMask = [
    /[0-9]/, /[0-9]/, /[0-9]/, '.',
    /[0-9]/, /[0-9]/, /[0-9]/, '.',
    /[0-9]/, /[0-9]/, /[0-9]/, '-',
    /[0-9]/, /[0-9]/];
  phoneMask = [
    '(', /[0-9]/, /[0-9]/, ')', ' ',
    /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-',
    /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/
  ];

  user: SocialUser;
  errorMessage = 'CPF ou senha incorretos.';

  markedMasc = false;
  theCheckboxMasc = false;

  markedFem = false;
  theCheckboxFem = false;

  ngOnChanges(changes: SimpleChanges) {
      const name: SimpleChange = changes.shoppingName;
  }

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private i18nService: I18nService,
              private authenticationService: AuthenticationService,
              private http: Http,
              private authService: AuthService,
              private customerService: CustomerService,
              private datePipe: DatePipe,
              private modalService: NgbModal,
              private route: ActivatedRoute,
              private util: UtilityService,
              private accreditedService: AccreditedService) {
    this.createForm();

    if (route.snapshot.data['isNew']) {
      this.isRegister = true;
    }


  }

  ngOnInit() {
    if (this.shoppingName) {
      this.isRegister = true;
    }
  }

  changeMasc(e: any) {
    this.markedMasc = e.target.checked;
    this.markedFem =  false;
  }

  changeFem(e: any) {
    this.markedFem = e.target.checked;
    this.markedMasc = false;
  }

  gotoAccredited() {
    this.isAccredited = true;
    this.util.setBarBackground('273e5d');
    this.util.setBarTextColor('ffffff');
  }

  backAccredited() {
    this.isAccredited = false;
    this.util.setBarBackground();
    this.util.setBarTextColor();
  }

  registerFacebookGoogle() {
    if (!this.isRegisterSocial) {
      this.authService.authState.subscribe((user) => {
        this.user = user;
        if (this.user) {
          this.isSocial = true;
          this.loginSocial();
        }
      });
    }
  }

  loginSocial() {
    this.isLoading = true;
    this.isFacebook = true;
    if (this.user.provider === GoogleLoginProvider.PROVIDER_ID) {
      this.isFacebook = false;
    }
    this.authenticationService.loginSocial(this.user, this.isFacebook)
      .pipe(finalize(() => {
        this.errorMessage = 'Usuário não cadastrado.';
        this.loginForm.markAsPristine();
        this.isLoading = false;
        this.isRegister = true;
      }))
      .subscribe(response => {
        if (response && response.status === 1) {
          this.router.navigate(['/'], { replaceUrl: true });
          return;
        }
        this.isRegister = true;
        this.customerRegister.name = response.name;
        this.customerRegister.email = response.email;

      }, error => {
        log.debug(`Login error: ${error}`);
        this.error = error;
      });
  }

  sendEmail(credentials: Credentials, successModal: any) {
    this.customerService.sendEmail(credentials)
      .pipe(finalize(() => {
      }))
      .subscribe(res => {
        if (res.ok) {
          this.isRegister = false;
          this.openRequestSucess(successModal);
        } else {
          alert('Erro ao realizar cadastro.');
        }

      }, error => {
        alert('Erro ao realizar cadastro.');
      });
  }

  openRequestSucess(content: any) {
    this.modalService.open(content, { windowClass: 'modal-centered modal-md' });
  }

  register(successModal: any) {
    const birthday = this.customerRegister.birthday.substring(0, 2) + '/'
      + this.customerRegister.birthday.substring(2, 4) + '/'
      + this.customerRegister.birthday.substring(4, 8);


    if (!this.markedMasc && !this.markedFem) {
      return;
    }



    const customerObj = Object.assign({}, this.customerRegister);
    customerObj.birthday = birthday;
    customerObj.gender = this.markedFem ? 2 : 1;

    customerObj.phone = this.customerRegister.phone.replace(/\D/g, '');
    customerObj.phone = ('55').concat(customerObj.phone);

    if (this.shoppingName) {
      customerObj.shoppingName = this.shoppingName;
    }

    let provider = CustomerService.WYNK_PROVIDER;
    let token = '';
    if (this.isSocial) {
      provider = this.isFacebook ? CustomerService.FACEBOOK_PROVIDER : CustomerService.GOOGLE_PROVIDER;
      token = this.isFacebook ? this.user.authToken : this.user.idToken;
    }

    this.customerService.preRegister(
      customerObj,
      this.passwordRegister,
      this.customerRegister.cpf,
      provider,
      token
    )
      .pipe(finalize(() => {
      }))
      .subscribe(credentials => {
        if (credentials && credentials.token) {

          if (this.shoppingName) {
              this.error = null;
              this.registerForm.markAsPristine();
              this.registerForm.reset();
              this.openRequestSucess(successModal);
              return;
          }

          this.authenticationService.setCredentials(credentials);
          this.sendEmail(credentials, successModal);
          this.error = null;
        } else {
          this.errorMessage = 'Erro ao realizar cadastro.';
          this.loginForm.markAsPristine();
          this.isLoading = false;
        }

      }, error => {
        this.errorMessage = error._body;
        log.debug(error);
        this.error = error;
      });
  }

  login(contentSu: any) {
    this.contentSucess = contentSu;
    this.isLoading = true;
    this.authenticationService.login(this.loginForm.value)
      .pipe(finalize(() => {
        this.errorMessage = 'Cpf ou senha incorretos.';
        this.loginForm.markAsPristine();
        this.isLoading = false;
      }))
      .subscribe(credentials => {
        this.modalService.open(this.contentSucess, { windowClass: 'modal-centered modal-md-350' });
        if (this.isModal) {
          this.util.closeLoginModal();
        }
        // if (this.redirectTo !== null) {
        //   const url = this.redirectTo || '/';
        //   this.router.navigate([url], { replaceUrl: true });
        // }
      }, error => {
        log.debug(`Login error: ${error}`);
        this.error = error;
      });
  }

  accreditedLogin() {
    this.isLoading = true;
    console.log(this.accreditedLoginForm.value);
    this.authenticationService.loginAccredited(this.accreditedLoginForm.value)
      .pipe(finalize(() => {
        this.errorMessage = 'Usuário ou senha incorretos.';
        this.loginForm.markAsPristine();
        this.isLoading = false;
      }))
      .subscribe(credentials => {
        log.debug(`${credentials.username} successfully logged in`);
        this.accreditedService.verify().subscribe(verifyReturn => {
          if (verifyReturn !== 'OK') {
            this.errorMessage = 'Ocorreu um erro ao realizar login';
            this.loginForm.markAsPristine();
            this.isLoading = false;
          }
          if (this.isModal) {
            this.util.closeLoginModal();
          }
          if (this.redirectTo !== null) {
            const url = this.redirectTo || '/accredited';
            this.router.navigate([url], { replaceUrl: true });
          }
        });
      }, error => {
        log.debug(`Login error: ${error}`);
        this.error = error;
      });
  }

  signInWithFB(): void {
    this.isFacebook = true;
    this.isSocial = true;
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
    this.registerFacebookGoogle();
  }

  signInWithGoogle(): void {
    this.isFacebook = false;
    this.isSocial = true;
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
    this.registerFacebookGoogle();
  }

  forgotPassword(modalComponent: any): void {
    this.forgotSended = false;
    this.forgotForm.markAsPristine();
    this.modalService.open(modalComponent, { windowClass: 'modal-centered modal-md-350' });
  }

  sendForgotPassword() {
    this.customerService.forgotPassword(this.forgotForm.value.email)
      .pipe(finalize(() => {
    }))
      .subscribe(res => {});
    this.forgotSended = true;
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: true
    });

    this.accreditedLoginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: true
    });

    this.registerForm = this.formBuilder.group ({
      name: ['', Validators.required],
      email: ['', Validators.compose([
        Validators.required, Validators.email
      ])],
      cpf: ['', Validators.required],
      birthday: ['', Validators.required],
      phone: ['', Validators.required],
      password: ['', Validators.required],
      gender: ['', Validators.requiredTrue]

    });

    // this.customerRegister.phone = '55';

    this.forgotForm = this.formBuilder.group ({
      email: ['', Validators.compose([
        Validators.required, Validators.email
      ])]
    });
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/login/login.component.ts